export const odluka_o_rasporedu_radnog_vremena = {
    templateId: 27,
    category: 3,
    templateTitle: 'Odluka o rasporedu radnog vremena',
    templateDescription: `<p>Poslodavac može samostalno utvrditi raspored radnog vremena posebnom odlukom, ukoliko određenim propisom, kolektivnim ugovorom, sporazumom, pravilnikom o radu ili ugovorom o radu nije određen raspored radnog vremena odnosno ukoliko je određen navedenim dokumentima, no poslodavcu omogućuje da samostalno određuje/mijenja tim dokumentima utvrđen raspored radnog vremena.</p>`,
    description: `
    <h5>OPIS DOKUMENTA</h5>
    <p>Radno vrijeme je vrijeme u kojem je radnik obvezan obavljati poslove, odnosno u kojem je spreman (raspoloživ) obavljati poslove prema uputama poslodavca, na mjestu gdje se njegovi poslovi obavljaju ili drugom mjestu koje odredi poslodavac.</p>
    <p>Vrijeme koje radnik provede obavljajući poslove po pozivu poslodavca smatra se radnim vremenom, neovisno o tome obavlja li ih u mjestu koje je odredio poslodavac ili u mjestu koje je odabrao radnik.</p>
    <p>Radnim vremenom se ne smatra vrijeme pripravnosti u kojemu se radnik ne nalazi na mjestu na kojem se njegovi poslovi obavljaju niti na drugom mjestu koje je odredio poslodavac, no za takvo vrijeme pripravnosti radnik ima pravo na naknadu čija visina se određuje ugovorom o radu ili kolektivnim ugovorom.</p>

    <p>Raspored radnog vremena utvrđuje se propisom, kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Ako raspored radnog vremena nije utvrđen prethodno navedenim dokumentima ili je utvrđen, ali na način da ostavlja mogućnost poslodavcu da samostalno promijeni/odredi raspored radnog vremena, o rasporedu radnog vremena odlučuje poslodavac pisanom odlukom.</p>
    <p>Posebnu pozornost treba obratiti na obveze poslodavca koje se odnose na prekovremeni rad, smjenski rad, noćni rad te rad u nejednakom rasporedu radnog vremena koje se suviše obuhvatne da bi se mogle obraditi ovim tekstom i primjerom dokumenta, a regulirane su Zakonom o radu.</p>
    <p><strong>Ukoliko je kod poslodavca utemeljeno radničko vijeće odnosno kod poslodavca postoji imenovan sindikalni povjerenik (koji preuzima sva prava i obveze radničkog vijeća propisane Zakonom o radu), poslodavac je dužan savjetovati se (za razliku od suglasnosti, gdje je pozitivno mišljenje preduvjet donošenja odluke) s radničkim vijećem/sindikalnim povjerenikom prije donošenja odluke o rasporedu radnog vremena.  Radničko vijeće/sindikalni povjerenik je u tom smislu dužno u roku od osam dana, dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu. Ako se radničko vijeće/sindikalni povjerenik ne očituje o namjeravanoj odluci u navedenom roku, smatra se da nema primjedbi i prijedloga. </strong> </p>
    <p><strong>Važno je naglasiti da poslodavac nije vezan očitovanjem radničkog vijeća/sindikata te svoju odluku može donijeti čak iako se navedeni protive istoj, no dužan je savjetovati se, jer je u protivnom odluka ništetna (ne proizvodi pravne učinke). </strong> </p>
    <h5>SVRHA DOKUMENTA</h5>
    <p>Najčešće se raspored radnog vremena određuje ugovorom o radu, no određivanje rasporeda radnog vremena, umjesto ugovorom o radu, predlaže se urediti posebnom odlukom o rasporedu radnog vremena.</p>
    <p>Naime, odlukom o rasporedu radnog vremena može se regulirati radno vrijeme kako za sve radnike zaposlene kod određenog poslodavca, tako i za radno vrijeme radnika pojedine organizacijske jedinice odnosno za svako radno mjesto ili svakog radnika posebno.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Obavijest o rasporedu ili promjeni radnog vremena nije dana pravovremeno - prekršaj</strong></p>
    <p>Pojašnjenje: poslodavac mora obavijestiti radnika o njegovu rasporedu ili promjeni njegova rasporeda radnog vremena najmanje tjedan dana unaprijed, <strong>osim u slučaju prijeke potrebe za radom radnika (prekovremeni rad), ako priroda prijeke potrebe onemogućava poslodavca da prije početka prekovremenog rada uruči radniku pisani zahtjev, usmeni zahtjev poslodavac je dužan pisano potvrditi u roku od sedam dana od dana kada je prekovremeni rad naložen.​</strong> Dakle, osim spomenutog izuzetka koji se odnosi na prekovremeni rad, tek nakon tjedan dana od obavijesti radnika o rasporedu radnog vremena radnik smije raditi prema rasporedu radnog vremena određenim odlukom.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O RASPOREDU RADNOG VREMENA',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,

            statements: [
                {
                type: 'choice',
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                            {
                                type: 'text',
                                mandatory: true,
                                editable: false,
                                content: 'Ovom Odlukom određuje se raspored radnog vremena svih radnika kod Poslodavca.',
                                value: '',
                            }]
                    },
                            {
                                type: 'input',
                                mandatory: true,
                                parts: [
                                    {
                                        type: 'text',
                                        content: 'Ovom Odlukom određuje se raspored radnog vremena radnika u organizacijskoj jedinici '
                                    },
                                    {type: 'input', value: '', required: true, help: 'Navesti naziv organizacijske jedinice na koju se raspored radnog vremena primjenjuje.'},],
                            },
                            {
                                type: 'input',
                                mandatory: true,
                                parts: [
                                    {
                                        type: 'text',
                                        content: 'Ovom Odlukom određuje se raspored radnog vremena radnika zaposlenih na sljedećim radnim mjestima: '},
                                    {type: 'input', value: '', required: true, help: 'Navesti naziv radnih mjesta na koje se raspored radnog vremena primjenjuje.',}],
                            }
                        ]
                    }],
                value: '',
            },
                {
                    title: '',
                    mandatory: true,
                    statements: [
                        {
                            type: 'choice',
                            mandatory: true,
                            editable: true,
                            choices: [
                                'Dnevno radno vrijeme je u pravilu jednokratno, na način određen ovom Odlukom.',
                                'Dnevno radno vrijeme je dvokratno, na način određen ovom Odlukom.',
                                'Dnevno radno vrijeme je višekratno, na način određen ovom Odlukom.'
                           ],
                           placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                        }
    
                    ]
                },
        {
                    title: '',
                    mandatory: true,
                    statements: [
                        {
                            type: 'choice',
                            mandatory: true,
                            editable: true,
                            choices: [
                                // 'Radno vrijeme raspoređeno je u 5 radnih dana, od ponedjeljka do petka (jednokratno), prema sljedećem rasporedu:' +
                                //     '- ponedjeljak do petak od 08,00h do 16,00 h, vikend slobodan',
                                'Radno vrijeme raspoređeno je u 5 radnih dana, od ponedjeljka do petka (jednokratno), prema sljedećem rasporedu:' +
                                ' - ponedjeljak:    od 08,00 h do 16,00 h,' +
                                ' - utorak:      	od 08,00 h do 16,00 h,' +
                                ' - srijeda:      	od 08,00 h do 16,00 h, ' +
                                ' - četvrtak:    	od 08,00 h do 16,00 h,' +
                                ' - petak:        	od 08,00 h do 16,00 h,' +
                                ' - subota:             neradna,' +
                                ' - nedjelja:           neradna',

                                'Radno vrijeme raspoređeno je u 6 radnih dana, od ponedjeljka do petka (jednokratno), prema sljedećem rasporedu:' +
                                ' - ponedjeljak:    od 08,00 h do 15,00 h,' +
                                ' - utorak:      	od 08,00 h do 15,00 h,' +
                                ' - srijeda:      	od 08,00 h do 15,00 h, ' +
                                ' - četvrtak:    	od 08,00 h do 15,00 h,' +
                                ' - petak:        	od 08,00 h do 15,00 h,' +
                                ' - subota:         od 08,00 h do 13,00 h,' +
                                ' - nedjelja:           neradna',

                                'Radno vrijeme raspoređeno je u 5 radnih dana, od ponedjeljka do petka (dvokratno), prema sljedećem rasporedu:' +
                                ' - ponedjeljak:      od 08,00 h do 12,00 h i od 16,00 h do 20,00 h' +
                                ' - utorak:      	    od 08,00 h do 16,00 h i od 16,00 h do 20,00 h' +
                                ' - srijeda:      	od 08,00 h do 16,00 h i od 16,00 h do 20,00 h,' +
                                ' - četvrtak:    	    od 08,00 h do 16,00 h i od 16,00 h do 20,00 hm' +
                                ' - petak:        	od 08,00 h do 16,00 h i od 16,00 h do 20,00 h,' +
                                ' - subota:              neradna,' +
                                ' - nedjelja:            neradna',

                                'Početak peterodnevnog radnog vremena (od ponedjeljka do petka)  radnika  (smjenski rad) utvrđuje se na sljedeći način:' +
                                ' a). radno vrijeme u prijepodnevnoj smjeni utvrđuje se kako slijedi: ' +
                                ' - ponedjeljak:         od 06,00 h do 14,00 h,' +
                                ' - utorak:      	       od 06,00 h do 14,00 h,' +
                                ' - srijeda:      	   od 06,00 h do 14,00 h,' +
                                ' - četvrtak:    	       od 06,00 h do 14,00 h,' +
                                ' - petak:        	   od 06,00 h do 14,00 h,' +
                                ' - subota:      	          neradna,' +
                                ' - nedjelja:      	      neradna' +

                                ' b).  radno vrijeme u poslijepodnevnoj smjeni utvrđuje se kako slijedi:' +
                                ' - ponedjeljak:         od 14,00 h do 22,00 h,' +
                                ' - utorak:      	       od 14,00 h do 22,00 h,' +
                                ' - srijeda:      	   od 14,00 h do 22,00 h,' +
                                ' - četvrtak:    	       od 14,00 h do 22,00 h,' +
                                ' - petak:        	   od 14,00 h do 22,00 h,' +
                                ' - subota:      	          neradna,' +
                                ' - nedjelja:      	      neradna', 'Tjedna izmjena smjena će se odvijati na način da svaki radnik na radnom mjestu određenom točkom a) ovog stavka,' +
                                ' u vremenskom razdoblju od dva radna tjedna naizmjenično radi obje smjene' +
                                ' opisane u točki ove odluke s time da će započeti s radom u smjeni pod a) ovog stavka.'
                            ],
                            placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                        }
                    ]
                },
                {
                    title: '',
                    mandatory: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Radnik koji radi najmanje šest sati dnevno ima svakoga radnog dana pravo na odmor (stanku) od najmanje trideset minuta.',
                            value: '',
                        }],
                },
                {
                    title: '',
                    mandatory: true,
                    statements: [
                        {
                            type: 'choice',
                            mandatory: true,
                            editable: false,
                            choices: [
                                {
                                    parts: [
                                        {
                                            type: 'text',
                                            content: 'Radnik će stanku (dnevni odmor) koristiti u tijeku radnog vremena, od'
                                        },
                                        {type: 'input', value: '', required: true},
                                        {type: 'text', content: 'do'},
                                        {type: 'input', value: '', required: true},
                                        {type: 'text', content: 'sati.'}
                                    ]
                                },
                                {
                                    parts: [
                                        {
                                            type: 'text',
                                            content: 'Radnik će stanku (dnevni odmor) koristiti u tijeku radnog vremena, u dva navrata, od'
                                        },
                                        {type: 'input', value: '', required: true},
                                        {type: 'text', content: 'do'},
                                        {type: 'input', value: '', required: true},
                                        {type: 'text', content: 'sati i od'},
                                        {type: 'input', value: '', required: true},
                                        {type: 'text', content: 'do'},
                                        {type: 'input', value: '', required: true},
                                        {type: 'text', content: 'sati.'}
                                    ]
                                },
                                {
                                    parts: [
                                        {
                                            type: 'text',
                                            content: 'Radnik će stanku (dnevni odmor) koristiti u tijeku radnog vremena, u vrijeme koje odredi prema vlastitom nahođenju, kada mu dnevne radne obveze to dopuste, no stanku ne može koristiti u periodu  do dva sata nakon početka rada odnosno u periodu od dva sata prije prestanka rada.'
                                        },
                                    ]
                                }],
                            value: '',
                        }
                    ]
                },
                {
                    title: '',
                    mandatory: true,
                    statements: [
                        {
                            type: 'text',
                            required: true,
                            mandatory: true,
                            editable: false,
                            content: 'Tijekom svakog vremenskog razdoblja od dvadeset četiri sata, radnik ima pravo na dnevni odmor od najmanje dvanaest sati neprekidno.',
                            value: '',
                        }],
                },

                {
                    title: '',
                    mandatory: true,
                    statements: [
                        {
                            type: 'text',
                            required: true,
                            mandatory: true,
                            editable: true,
                            content: 'Radni tjedan traje sveukupno 40 sati.',
                            value: '',
                        }],
                },
                {
                    title: '',
                    mandatory: true,
                    editable: false,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: false,
                            content: '\r\nDani tjednog odmora određeni su ovom odlukom, no radnik ima pravo na tjedni odmor u trajanju od najmanje 24 sata neprekidno, kojemu se pribraja dnevni odmor.',
                            value: '',
                        },
                        {
                            type: "text",
                            mandatory: true,
                            editable: false,
                            content: "\r\nTjedni odmor radnik koristi nedjeljom te u dan koji nedjelji prethodi, odnosno iza nje slijedi.",
                          },
                        {
                            type: "text",
                            mandatory: true,
                            editable: false,
                            content: "\r\nAko radnik ne može koristiti odmor u trajanju navedenom u ovom članku, mora mu se za svaki radni tjedan omogućiti korištenje zamjenskog tjednog odmora odmah po okončanju razdoblja koje je proveo na radu, zbog kojeg tjedni odmor nije koristio ili ga je koristio u kraćem trajanju.",
                          },
                        {
                            type: "text",
                            mandatory: true,
                            editable: false,
                            content: "\r\nIznimno, radnicima koji zbog obavljanja posla u različitim smjenama ili objektivno nužnih tehničkih razloga ili zbog organizacije rada ne mogu iskoristiti odmor u trajanju iz ovoga članka, pravo na tjedni odmor može biti određeno u neprekidnom trajanju od najmanje dvadeset četiri sata, kojemu se pribraja dnevni odmor.",
                          },],
                },
                {
                    title: '',
                    mandatory: false,
                    editable: true,
                    statements: [
                        {
                            type: 'text',
                            required: false,
                            mandatory: true,
                            editable: true,
                            content: 'Rad treba na vrijeme započeti i ne smije se prije vremena završiti.',
                            value: '',
                        }],
                },
                {
                    title: '',
                    mandatory: false,
                    editable: true,
                    statements: [
                        {
                            type: 'text',
                            required: false,
                            mandatory: true,
                            editable: true,
                            content: 'Odredbe ove Odluke ne primjenjuju se na radnike zaposlene na nepuno radno vrijeme te je njihov raspored radnog vremena određenom ugovorom o radu ili posebnom odlukom o rasporedu radnog vremena. ',
                            value: '',
                        }],
                },
                {
                    title: "",
                    mandatory: false,
                    statements: [
                      {
                        type: "choice",
                        mandatory: true,
                        editable: false,
                        choices: [
                          {
                            parts: [
                              { type: "text", content: "Poslodavac je dana " },
                              { type: "input", value: "", required: true },
                              { type: "text", content: "godine priopćio radničkom vijeću namjeru donošenja Odluke u te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se radničko vijeće pozitivno očitovalo dana " },
                              { type: "input", value: "", required: true, help: "Prije donošenja ove odluke, poslodavac se dužan savjetovati s radničkim vijećem, ukoliko isto postoji kod poslodavca. Radničko vijeće je dužno u roku od osam dana dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu." },
                            ]
                          },
                          {
                            parts: [
                              { type: "text", content: "Poslodavac je dana " },
                              { type: "input", value: "", required: true },
                              { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se sindikalni povjerenik očitovao pozitivno dana " },
                              { type: "input", value: "", required: true, help: "Ako kod poslodavca nije utemeljeno radničko vijeće, a kod Poslodavca djeluje sindikalni povjerenik, isti preuzima sva prava i obveze radničkog vijeća te je u tom smislu dužan ju roku od osam dana dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu. U tom smislu, Poslodavac je dužan prije ove odluke, prethodno se savjetovati sa sindikalnim povjerenikom." },
                            ]
                          },
                          {
                            parts: [
                              { type: "text", content: "Poslodavac je dana " },
                              { type: "input", value: "", required: true },
                              { type: "text", content: "godine priopćio radničkom vijeću namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se radničko vijeće nije očitovalo u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga." },
                            ]
                          },
                          {
                            parts: [
                              { type: "text", content: "Poslodavac je dana " },
                              { type: "input", value: "", required: true },
                              { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se sindikalni povjerenik nije očitovao u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga." },
                            ]
                          },
                          {
                            parts: [
                              { type: "text", content: "Poslodavac je dana " },
                              { type: "input", value: "", required: true },
                              { type: "text", content: "godine priopćio radničkom vijeću namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se radničko vijeće očitovalo negativno, no Poslodavac ipak donosi ovu Odluku." },
                            ]
                          },
                          {
                            parts: [
                              { type: "text", content: "Poslodavac je dana " },
                              { type: "input", value: "", required: true },
                              { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se sindikalni povjerenik očitovao negativno, no Poslodavac ipak donosi ovu Odluku." },
                            ]
                          }],
                      },
                    ]
                  },
                {
                    title: '',
                    statements: [
                        {
                            type: 'input',
                            mandatory: true,
                            editable: false,
                            parts: [
                                {type: 'text', content: 'Ova odluka stupa na snagu'},
                                {type: 'input', value: '', required: true, help: 'Poslodavac mora obavijestiti radnika o njegovu rasporedu ili promjeni njegova rasporeda radnog vremena najmanje tjedan dana unaprijed, osim u slučaju prijeke potrebe za radom radnika. Dakle, tek nakon tjedan dana od obavijesti radnika o rasporedu radnog vremena radnik smije raditi prema rasporedu radnog vremena određenom odlukom.'},
                                {type: 'text', content: ', a primjenjuje se do opoziva.'}],
                        }],
                    value: '',
                },

                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Dostaviti:\r\n1) Radnicima \r\n2) Kadrovska služba',
                            help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                        }
                    ]
                },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/27_odluka_o_rasporedu_radnog_vremena.ts